module.exports = __webpack_public_path__ + "static/media/cover-real-size.ac78bba7.jpg";